
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_PAYMENT_CARDS from "@/apollo/payment/GetPaymentCards.gql";
  import GET_PAYMENT_CARDS_ESSENTIAL from "@/apollo/payment/GetPaymentCardsEssential.gql";

  import FormWrapper from "@/components/form/FormWrapper.vue";
  import PaymentCard from "@/components/payment/PaymentCard.vue";
  import PaymentCardPlaceholder from "@/components/skeletonPlaceholder/components/PaymentCardPlaceholder.vue";
  import EditPaymentCardModal from "@/components/payment/EditPaymentCardModal.vue";

  import { Payment_Card, User } from "@/generated/graphql";
  import UiButton from "@/components/button/ui-button.vue";
  import AddPaymentCardModal from "@/components/payment/AddPaymentCardModal.vue";

  @Component({
    components: {
      AddPaymentCardModal,
      UiButton,
      PaymentCard,
      FormWrapper,
      PaymentCardPlaceholder,
      EditPaymentCardModal,
    },
    apollo: {
      paymentCardsFullInfo: {
        query: GET_PAYMENT_CARDS,
        variables() {
          return {
            userId: this.currentUser.id,
            subscriptionId: this.currentSubscriptionId,
          };
        },
        update(data) {
          this.paymentCards = data.payment_card;
          this.currentSubscriptionRenewable = !data.subscription_by_pk.cancel_at_period_end;
        },
        skip() {
          return !this.currentUser.subscription_required;
        }
      },
      paymentCardsEssential: {
        query: GET_PAYMENT_CARDS_ESSENTIAL,
        variables() {
          return {
            userId: this.currentUser.id,
          };
        },
        update(data) {
          this.paymentCards = data.payment_card;
        },
        skip() {
          return this.currentUser.subscription_required;
        }
      },
    },
  })
  export default class PaymentSettings extends Vue {
    @Prop({ type: Object, required: true }) currentUser!: User;

    paymentCards: Payment_Card[] = [];
    currentSubscriptionRenewable?: boolean;

    get currentSubscriptionId(): string {
      return this.currentUser.admin!.company.subscriptions[0]?.id;
    }

    get cardActionButtonText(): string | undefined {
      if (this.currentSubscriptionRenewable !== false) {
        return;
      }

      return "Add credit card";
    }

    get paymentCardsExist(): boolean {
      return this.paymentCards.length > 0;
    }

    get isLoading(): boolean {
      return this.$apollo.queries.paymentCardsFullInfo.loading || this.$apollo.queries.paymentCardsEssential.loading;
    }

    get needPaymentCard(): boolean {
      return this.currentUser.subscription_required;
    }

    refetch() {
      this.$apollo.queries.paymentCardsFullInfo.refetch();
      this.$apollo.queries.paymentCardsEssential.refetch();
    }
  }
